const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}') || {};

export const config = {
  mixins: [],
  data() {
    return {
      columns: []
    };
  },
  methods: {
    // 获取表格列
    getColumns() {
      const status = this.searchParams.status;
      let columns = [
        {
          title: '预约签单日期',
          key: 'appointSignDate',
          align: 'center',
          minWidth: 130,
          render(h, params) {
            const text = params.row.appointSignDate || '';
            const icon = params.row.isReferral == 1 ? <Icon type="md-star" style="margin-right: 4px;" /> : null;
            return <div>{icon}{text.substr(0, 10)}<br/>{text.substr(10, 6)}</div>;
          }
        },
        {
          title: '创建时间',
          align: 'center',
          key: 'createTime',
          width: 100,
          render(h, params) {
            return <div>{params.row.createTime.substr(0, 16)}</div>;
          }
        },
      ];
      if (status == '3') {
        columns.push({
          title: '签约保单号',
          align: 'center',
          slot: 'policyNo',
          width: 120
        });
      }
      columns = columns.concat([
        {
          title: '保险公司',
          key: 'companyName',
          align: 'center',
          width: 100
        },
        {
          title: '产品名称',
          key: 'productName',
          align: 'center',
          minWidth: 160
        },
        {
          title: '年缴保费',
          slot: 'fee',
          align: 'center',
          width: 150,
        },
        {
          title: '投保人',
          slot: 'name',
          align: 'center',
          minWidth: 100,
        },
        {
          title: '受保人',
          key: 'insuranceName',
          align: 'center',
          minWidth: 100
        },
        {
          title: '是否预缴',
          align: 'center',
          key: 'isPrePay',
          width: 80,
          render(h, params) {
            if(params.row.isPrePay == 1) {
              return <span class="my-tag min green">是</span>
            }else{
              return <span class="my-tag min">否</span>
            }
          }
        },
      ]);
      if (status == 'null' || status == '2' || status == '3') {
        columns.push({
          title: '業務代表',
          align: 'center',
          slot: 'TR',
          width: 100
        });
      }
      columns = columns.concat([
        {
          title: '签单地点',
          slot: 'signAddr',
          align: 'center',
          minWidth: 120,
          tooltip: true
        },
        {
          title: '申请人',
          align: 'center',
          key: 'agentName',
          width: 150,
          render(h, params) {
            let text;
            if (params.row.agentName) {
              text = params.row.orgName + '—' + params.row.agentName;
            } else {
              text = params.row.orgName;
            }
            return <div>{text || '-'}</div>;
          }
        },
        {
          title: '预约状态',
          align: 'center',
          slot: 'status',
          width: 100,
          fixed: 'right'
        }
      ]);
      if (status == 'null') {
        columns.push({
          title: '签约保单号',
          align: 'center',
          slot: 'policyNo',
          width: 120
        });
      }
      const widthMap = {
        '-1': 130,
        '0': 130,
        '1': 100,
        '2': 160,
        '3': 100,
        'null': 160
      };
      columns.push({
        title: '操作',
        align: 'center',
        slot: 'action',
        width: widthMap[status] || 160,
        fixed: 'right'
      });
      this.columns = columns;
    }
  }
};
